<template>
  <div>
    <aside
      class="about"
      aria-modal="true"
      role="dialog"
      ref="wrapper"
      @click.self="handleClose"
    >
      <div class="about__modal c-text-alt" ref="content">
        <div class="about__modal__inner">
          <div class="intro fs-60 sp-45">
            <p data-split>{{ data.intro }}</p>
          </div>
          <AboutAwards
            class="sp-180"
            :projects="data.project_awards"
            :solo="data.solo_awards"
            :projectsTitle="data.project_awards_title"
            :soloTitle="data.solo_awards_title"
          />
          <AboutDescription class="sp-60" :description="data.description" />
          <AboutServices
            class="sp-300"
            :title="data.services_label"
            :dev="data.services_development"
            :design="data.services_design"
            :media="data.media"
          />
          <AboutFooter
            :cta="data.cta"
            :addText="data.footer_addictional_label"
          />
        </div>
      </div>
    </aside>
    <AboutClose v-if="isModalVisible" @click="handleClose" />
  </div>
</template>

<script setup>
const wrapper = ref(null);
const content = ref(null);
const props = defineProps({
  data: { type: Object, default: null },
});
const { $gsap: gsap } = useNuxtApp();
const isMenuOpen = useMenuOpen();
const { $eventBus } = useNuxtApp();
const { scrollProgress, animateOut, initSplitText, cleanup } = useAbout(
  wrapper,
  content
);
const isModalVisible = useAboutModal();

const handleClose = () => {
  animateOut();
};

const handleEscape = e => {
  if (e.key === 'Escape') {
    handleClose();
  }
};

onMounted(() => {
  if (isMenuOpen.value) {
    $eventBus.emit('closeMenu');
  }
  initSplitText();
  window.addEventListener('keydown', handleEscape);
});

onUnmounted(() => {
  cleanup();
  window.removeEventListener('keydown', handleEscape);
});
</script>

<style lang="scss" scoped>
.about {
  display: flex;
  height: var(--height);
  justify-content: center;
  overflow: scroll;
  position: fixed;
  width: 100vw;
  z-index: layer(modal);
  top: 0;
  user-select: none;
  will-change: transform;
  @include noScrollbar;

  @include mq(desktop) {
    justify-content: flex-end;
  }

  &:deep(.line) {
    // white-space: pre-line;
    transform: translateY(100%);
    transition: transform 1s ease(outExpo) calc((var(--index) * 0.05s) + 0.05s);
  }

  &.is-animated:deep(.line) {
    transform: translateY(0%);
  }
}

.about__modal {
  background: var(--c-alt);
  border-radius: var(--radius);
  bottom: var(--gutter);
  display: flex;
  flex-direction: column;
  height: fit-content;
  margin-top: var(--height);
  min-height: var(--height);
  overflow: clip;
  padding: var(--offset);
  position: relative;
  width: calc(100vw - var(--gutter-double));
  will-change: transform;

  @include mq(desktop) {
    right: var(--gutter);
    width: calc(var(--offset) + var(--col-5));
  }
}

.about__progress {
  bottom: var(--offset);
  position: fixed;
  right: calc(col(5) + var(--offset-double));
}
</style>
